export default __webpack_public_path__ + "static/media/ravenprotocol-logo-white.91f152c4.png";